import React from 'react';
import { DeleteTwoTone, PlusCircleTwoTone } from '@ant-design/icons';
import editImage from '../../../../assets/bx_msg_square_edit.png';
import { withRouter } from 'react-router-dom';
import { Button, Divider, Input, message, Modal, Tooltip } from 'antd';
import style from '../../typologyListingDashboard/runInstanceHandlerClass/index.scss';
import componentStyle from './index.scss';

import { getRoleOfLoggedInUser } from '../../../tm/investigationDetail/InvestDetailHeader/investDetailHeaderUtil';
import { TRM_CONSTANTS } from '../../../constants/trmConstants';
import { isResourceAvailable } from '../../../../util';
import { getSelectedResources } from '../../../../util/resourceManager';

import {
  capitalize,
  keys,
  lowerCase,
  startCase,
  trim
} from '../../../../util/lodashlike';
const { TextArea } = Input;
const { trmResources } = getSelectedResources();

/**
 * AddToBucketComponent
 * @param props
 * @returns {*}
 * @constructor
 */
export const AddToBucketComponent = ({ onAddTypologyToScenario, typology }) => {
  return (
    <div
      onClick={() => onAddTypologyToScenario(typology)}
      className={componentStyle.addBucketComponentClass}>
      <PlusCircleTwoTone />
    </div>
  );
};

/**
 * TextComponent
 * @param id
 * @param style
 * @param className
 * @param showTooltip
 * @returns {*}
 * @constructor
 */
export const TextComponent = ({
  id,
  style = {},
  className = '',
  showTooltip = false
}) => {
  const component = (
    <div
      className={className}
      style={{
        marginLeft: 10,
        marginRight: 10,
        ...style
      }}>
      {id}
    </div>
  );

  return showTooltip ? <Tooltip title={id}>{component}</Tooltip> : component;
};

/**
 * TitleComponent
 * @param title
 * @returns {*}
 * @constructor
 */
export const TitleComponent = ({ title }) => {
  return (
    <div className={componentStyle.titleComponentClass}>
      <div>{title}</div>
    </div>
  );
};

/**
 * NotesComponent
 * @param notes
 * @returns {*}
 * @constructor
 */
export const NotesComponent = ({ notes = [] }) => {
  return (
    <div className={componentStyle.notesComponent}>
      <div>{notes.length > 0 ? notes.length : 0}</div>
      <img src={editImage} style={{ width: 16, height: 16 }} alt={''} />
    </div>
  );
};

/**
 * AlertsLevelComponent
 * @returns {*}
 * @constructor
 */
export const AlertsLevelComponent = ({ alertLevelConfig }) => {
  return (
    <div className={componentStyle.alertsLevelComponent}>
      {alertLevelConfig?.map(
        ({ alertLevelCode, alertLevelColor, alertLevelLabel, count }) => (
          <div key={alertLevelCode} style={{ color: alertLevelColor }}>
            {alertLevelLabel || capitalize(alertLevelCode)}: {count}
          </div>
        )
      )}
    </div>
  );
};

/**
 * AlertsLevelFraudComponent
 * @returns {*}
 * @constructor
 */
// FIN-12133: getActionColor(action) resolves the action's configured severity's
// level colour (action_severity -> alert_level_details). Supplied by the caller;
// falls back to the legacy field if absent.
export const AlertsLevelFraudComponent = ({
  actionCount,
  actionList,
  getActionColor
}) => {
  return (
    <div className={componentStyle.alertsLevelFraudComponent}>
      {keys(actionCount).map((key) => {
        const actionType = actionList.find(
          ({ displayName }) => displayName?.toLowerCase() === key?.toLowerCase()
        );
        const color = getActionColor
          ? getActionColor(key)
          : actionType?.alertLevelColor;

        return (
          <div key={key} style={{ color }}>
            {key}: {actionCount[key]}
          </div>
        );
      })}
    </div>
  );
};

/**
 * ConfigureAndRerunComponent
 */
export class ConfigureAndRerunComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false,
      newScenarioText: `Clone - ${props.scenario.name}`,
      EXCECUTE_ACCESS: false
    };
  }

  componentDidMount() {
    const { authentication } = this.props;
    let EXCECUTE_ACCESS_CONFIGURE_RERUN = isResourceAvailable(
      { data: authentication },
      trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE
    );
    this.setState({
      EXCECUTE_ACCESS: EXCECUTE_ACCESS_CONFIGURE_RERUN
    });
  }

  toggleModal = () => {
    this.setState({ isModalVisible: !this.state.isModalVisible });
  };

  handleOk = () => {
    if (trim(this.state.newScenarioText).length === 0) {
      message.error('Scenario cannot be empty');
      return;
    }

    if (this.state.newScenarioText.length > 50) {
      message.error('Scenario cannot be more than 50 chars');
      return;
    }

    const { scenario } = this.props || {};
    console.log({ scenario });
    const { id = '', sourceId = '' } = scenario || {};
    this.props.dispatchCloneScenario({
      originalId: id,
      name: this.state.newScenarioText,
      sourceId: sourceId
    });
    this.toggleModal();
    this.setState({ newScenarioText: '' });
    // this.props.onRerun();
  };

  handleCancel = () => {
    this.toggleModal();
    this.setState({ newScenarioText: '' });
  };

  onNewScenarioText = (event) => {
    this.setState({ newScenarioText: event.target.value });
  };

  render() {
    const { scenario = {} } = this.props || {};
    const { latestInstance = {}, id = '', name = '' } = scenario;
    const { IN_QUEUE } = TRM_CONSTANTS;
    const { status = IN_QUEUE } = latestInstance;
    const { isModalVisible } = this.state;
    return (
      <div className={componentStyle.displayFlexJustifyAlignCenter}>
        <TTLink
          btnText={'Configure'}
          routeToGo={'/app/trm/configure/' + id}
          EXCECUTE_ACCESS={this.state.EXCECUTE_ACCESS}
        />
        {status !== IN_QUEUE && (
          <Divider style={{ backgroundColor: '#748AA1' }} type="vertical" />
        )}
        {status !== IN_QUEUE && (
          <div
            style={{
              color: this.state.EXCECUTE_ACCESS ? '#0C8ED7' : '#778899',
              fontSize: 12,
              cursor: this.state.EXCECUTE_ACCESS ? 'pointer' : 'not-allowed'
            }}
            onClick={this.state.EXCECUTE_ACCESS && this.toggleModal}>
            Re-Run
          </div>
        )}
        <Modal
          title={name}
          destroyOnClose={true}
          maskClosable={false}
          visible={isModalVisible}
          width={534}
          okText={'Confirm'}
          bodyStyle={{ height: 200 }}
          onOk={this.handleOk}
          onCancel={this.handleCancel}>
          <div>
            <div className={style.newScenarioInputContainer}>
              Create a new scenario
            </div>
            <div className={componentStyle.displayFlexAlignCenter}>
              <Input
                onChange={this.onNewScenarioText}
                value={this.state.newScenarioText}
                style={{ height: 32, width: 365, marginRight: 14 }}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

/**
 * ApproveOrRejectComponent
 */
export class ApproveOrRejectComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSuperVisor: false,
      isAnalyst: false,
      isModalVisible: false,
      ticketState: '',
      EXCECUTE_ACCESS: false
    };
    this.APPROVE = 'approve';
    this.REJECT = 'reject';
  }

  componentDidMount() {
    let EXCECUTE_ACCESS_APPRIVE_REJECT = isResourceAvailable(
      { data: this.props.authentication },
      trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET
    );
    this.setState({
      EXCECUTE_ACCESS: EXCECUTE_ACCESS_APPRIVE_REJECT
    });

    const { isSuperVisor, isAnalyst } = getRoleOfLoggedInUser(
      this.props.authentication
    );
    this.setState({ isSuperVisor, isAnalyst });
  }

  toggleModal = (ticketState = '') => {
    this.setState({
      isModalVisible: !this.state.isModalVisible,
      ticketState,
      rejectionReason: ''
    });
  };

  handleOk = () => {
    if (this.state.ticketState === this.APPROVE) {
      this.props.onAction({
        actionType: this.APPROVE,
        instanceID: this.props.ticket.id
      });
    }
    if (this.state.ticketState === this.REJECT) {
      const { rejectionReason } = this.state;
      if (rejectionReason.length === 0 || trim(rejectionReason).length === 0) {
        message.error('The rejection reason cannot be empty');
        return;
      }
      if (rejectionReason.length < 10 || trim(rejectionReason).length < 10) {
        message.error('The rejection reason is too small');
        return;
      }

      this.props.onAction({
        actionType: this.REJECT,
        note: this.state.rejectionReason,
        instanceID: this.props.ticket.id
      });
    }
    this.toggleModal();
  };

  handleCancel = () => {
    this.toggleModal();
  };

  onRejectionReasonChange = (event) => {
    this.setState({ rejectionReason: event.target.value });
  };

  // For Table View
  statusWithColor = (status) => (
    <div
      className={componentStyle.buttonStyle}
      style={{ color: status == 'approved' ? 'green' : 'red' }}>
      {' '}
      {startCase(status)}{' '}
    </div>
  );

  render() {
    const {
      ticket,
      showButtons = false,
      showLinks = false,
      inDetail = false,
      btnText = 'Approve'
    } = this.props || {};
    const { id = '', state = '' } = ticket || {};
    const { isModalVisible, isAnalyst } = this.state;
    const ticketStatus = trim(lowerCase(state));

    return (
      <div className={componentStyle.displayFlexJustifyStartAlignCenter}>
        <Modal
          title={
            this.state.ticketState === this.REJECT ? 'Rejection Reason' : ''
          }
          destroyOnClose={true}
          maskClosable={false}
          visible={isModalVisible}
          okText={'Confirm'}
          onOk={this.handleOk}
          onCancel={this.handleCancel}>
          <div>
            {this.state.ticketState !== this.REJECT && (
              <span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z"
                    fill="#FAAD14"
                  />
                  <path
                    d="M10.875 16.125C10.875 16.4234 10.9935 16.7095 11.2045 16.9205C11.4155 17.1315 11.7016 17.25 12 17.25C12.2984 17.25 12.5845 17.1315 12.7955 16.9205C13.0065 16.7095 13.125 16.4234 13.125 16.125C13.125 15.8266 13.0065 15.5405 12.7955 15.3295C12.5845 15.1185 12.2984 15 12 15C11.7016 15 11.4155 15.1185 11.2045 15.3295C10.9935 15.5405 10.875 15.8266 10.875 16.125ZM11.4375 13.5H12.5625C12.6656 13.5 12.75 13.4156 12.75 13.3125V6.9375C12.75 6.83437 12.6656 6.75 12.5625 6.75H11.4375C11.3344 6.75 11.25 6.83437 11.25 6.9375V13.3125C11.25 13.4156 11.3344 13.5 11.4375 13.5Z"
                    fill="#FAAD14"
                  />
                </svg>{' '}
                &nbsp;&nbsp;
                <b>Approve the New Challenger?</b>{' '}
              </span>
            )}

            {this.state.ticketState === this.REJECT && (
              <div>
                <div className={componentStyle.titleClass}>
                  Rejection Reason
                </div>
                <div>
                  <TextArea
                    onChange={this.onRejectionReasonChange}
                    placeholder={'Please enter your notes here'}
                    rows={8}
                  />
                </div>
              </div>
            )}
          </div>
        </Modal>
        {/* For Table View (Buttons) */}
        {showLinks && ticketStatus == 'created' && (
          <>
            <div
              className={
                this.state.EXCECUTE_ACCESS
                  ? componentStyle.approveBtn
                  : componentStyle.approveBtnDisabled
              }
              onClick={() =>
                this.state.EXCECUTE_ACCESS && this.toggleModal(this.APPROVE)
              }>
              Approve
            </div>
            <Divider style={{ backgroundColor: '#748AA1' }} type="vertical" />
            <div
              className={
                this.state.EXCECUTE_ACCESS
                  ? componentStyle.rejectBtn
                  : componentStyle.rejectBtnDisabled
              }
              onClick={() =>
                this.state.EXCECUTE_ACCESS && this.toggleModal(this.REJECT)
              }>
              Reject
            </div>
          </>
        )}

        {/* For Table and Challenger/Champion Page  After Approve or Reject  */}
        {!(ticketStatus == 'created') && this.statusWithColor(ticketStatus)}

        {/* For Challenger/Champion Page */}
        {showButtons && ticketStatus == 'created' && (
          <>
            <Button
              style={{
                backgroundColor: '#F7F7F8',
                border: '1px solid #D0D7E3',
                borderRadius: 4,
                color: '#DF6057',
                marginRight: 15
              }}
              type="secondary"
              onClick={() => this.toggleModal(this.REJECT)}>
              Reject
            </Button>
            <Button
              style={{ backgroundColor: '#0C8ED7', borderRadius: 4 }}
              type="primary"
              onClick={() => this.toggleModal(this.APPROVE)}>
              {btnText}
            </Button>
          </>
        )}
      </div>
    );
  }
}

/**
 * RevertComponent
 */
export class RevertComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSuperVisor: false,
      isModalVisible: false,
      revetActionAccess: false
    };
  }

  componentDidMount() {
    const { authentication } = this.props;
    let REVERT_ACTION_ACCESS = isResourceAvailable(
      { data: authentication },
      trmResources.APP_3_RESOURCE_UI_AMLS_CHAMPION_UPDATE
    );
    this.setState({
      revetActionAccess: REVERT_ACTION_ACCESS
    });
    const { isSuperVisor } = getRoleOfLoggedInUser(authentication);
    this.setState({ isSuperVisor });
  }

  toggleModal = () => {
    this.setState({
      isModalVisible: !this.state.isModalVisible
    });
  };

  handleOk = () => {
    const { champion, onAction } = this.props;
    const { challengerId } = champion || {};

    if (onAction && champion && challengerId) {
      onAction(challengerId);
    }
    this.toggleModal();
  };

  handleCancel = () => {
    this.toggleModal();
  };

  render() {
    const { isModalVisible } = this.state;

    return (
      <div className={componentStyle.displayFlexJustifyAndAlignCenter}>
        <Modal
          title={'Revert Champion'}
          destroyOnClose={true}
          maskClosable={false}
          visible={isModalVisible}
          okText={'Confirm'}
          onOk={this.handleOk}
          onCancel={this.handleCancel}>
          <div>
            <div>Revert the Champion?</div>
          </div>
        </Modal>
        <div
          className={
            this.state.revetActionAccess
              ? componentStyle.revertBtn
              : componentStyle.revertBtnDisabled
          }
          onClick={this.state.revetActionAccess ? this.toggleModal : undefined}>
          Revert
        </div>
      </div>
    );
  }
}

/**
 * DeleteComponent
 * @returns {*}
 * @constructor
 */
export const DeleteComponent = () => {
  return (
    <div className={componentStyle.deleteComponent}>
      <DeleteTwoTone twoToneColor="#DF6057" />
    </div>
  );
};
/**
 * TTButton
 */
export const TTButton = withRouter(
  ({
    history,
    btnText,
    routeToGo,
    style = {},
    btnType = 'primary',
    icon = '',
    onRedirect = () => {},
    disabled = false,
    className
  }) => (
    <Button
      disabled={disabled}
      icon={icon ? icon : <></>}
      style={{
        width: 190,
        backgroundColor: disabled ? '' : '#0C8ED7',
        ...style
      }}
      onClick={() => {
        onRedirect();
        history.push(routeToGo);
      }}
      type={btnType}
      className={className}>
      {btnText}
    </Button>
  )
);

/**
 * TTLink
 */
export const TTLink = withRouter(
  ({
    history,
    btnText,
    routeToGo,
    EXCECUTE_ACCESS,
    style = {},
    onRedirect = () => {}
  }) => (
    <div
      style={{
        color: EXCECUTE_ACCESS ? '#0C8ED7' : '#778899',
        cursor: EXCECUTE_ACCESS ? 'pointer' : 'not-allowed',
        fontSize: 12,
        ...style
      }}
      onClick={() => {
        EXCECUTE_ACCESS ? (onRedirect(), history.push(routeToGo)) : '';
      }}>
      {btnText}
    </div>
  )
);
